import React, { useState } from 'react';
import PropTypes from 'prop-types';
import DatePicker from './DatePicker';
import { ERROR } from '../../../constants/shared/CommonConstants';
import { WEB_ENTRY_DATE } from '../../../constants/shared/WebEntryConstants';

const DateCell = ({
    isNotEditable,
    dateString,
    dateStringClassName,
    datePicker,
    isRowDisabled,
}) => {
    const {
        date,
        datePickerRef,
        showAllStudentsCheckbox,
        className,
        handleDateValueChange,
        handleKeyDown,
        setIsRowFocused,
        error,
    } = datePicker;

    const [isOpened, setIsOpened] = useState(false);

    const handleDropdownToggle = isOpen => {
        setIsOpened(isOpen);
        if (isOpen) {
            setIsRowFocused(true);
        }
    };
    const isDateError =
        error && error.highlightedInputs.find(inputName => inputName === WEB_ENTRY_DATE.DATE);

    if (isNotEditable || isRowDisabled) {
        return (
            <div className={`display-container ${dateStringClassName}`}>
                <div className="display-value">{dateString || '- -'}</div>
            </div>
        );
    }

    return (
        <div className={`input-container ${className}`}>
            <DatePicker
                date={date}
                datePickerRef={datePickerRef}
                handleChange={handleDateValueChange}
                handleKeyDown={handleKeyDown}
                handleDropdownToggle={handleDropdownToggle}
                isOpen={isOpened}
                datePickerClassName={isDateError ? ERROR : ''}
                showAllStudentsCheckbox={showAllStudentsCheckbox}
            />
        </div>
    );
};

DateCell.defaultProps = {
    isNotEditable: false,
    dateString: '',
    dateStringClassName: '',
    datePicker: {},
    isRowDisabled: false,
};

DateCell.propTypes = {
    isNotEditable: PropTypes.bool,
    dateString: PropTypes.string,
    dateStringClassName: PropTypes.string,
    datePicker: PropTypes.object,
    isRowDisabled: PropTypes.bool,
};

export default DateCell;
